<template>
    <div>
        <div class="flex flex-col items-start justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40 text-left">
            <h2 class="self-center mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">Impressum</h2>
            <p class="mt-2 font-semibold text-lg">
                Anschrift
            </p>
            <p>STUDIO HOLZBACH</p>
            <p>Werkraum Dom 56</p>
            <p>Domstrasse 56</p>
            <p>50668 Köln</p>
            <p class="mt-2 font-semibold text-lg">
                E-Mail
            </p>
            <p>info@markus-holzbach.de</p>
            <p class="mt-2 font-semibold text-lg">
                Verantwortlicher für Redaktion/Inhalt
            </p>
            <p>Prof. Dr.-Ing. Architekt Markus Holzbach (Anschrift s.o.)</p>
            <p>Mitglied der Architektenkammer Rheinland-Pfalz</p>
            <p>Mitglieds-Nr. 17520</p>
            <p class="mt-2 font-semibold text-lg">
                Webseite
            </p>
            <p><a href="https://pixel-shift.de/">Pixel Shift GmbH</a></p>
            <br>
            <p class="mt-2 font-semibold text-lg">
                Urheber
            </p>
            <p>Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützte Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweilig eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluß zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte, bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {},
    data ()
    {
        return {};
    },
    methods: {},
    created () { },
};
</script>